module.exports = __webpack_public_path__ + "img/p1-p1-molihua.425dddc4.png";